import { createConsumer } from "@rails/actioncable";

const token = localStorage.getItem("token");

// Determine the appropriate WebSocket URL based on the current environment
const getWebSocketUrl = () => {
  // Check if we're running on Netlify (production)
  if (window.location.hostname === 'roaring-cupcake-08c9cb.netlify.app') {
    return 'wss://api.stylistgpt.ai/cable';
  }

  // For local development, connect to local Rails server
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'ws://localhost:3000/cable';
  }

  // Use environment variable if available, otherwise fallback to production
  return (
    (import.meta as any).env.VITE_CABLE_URL || "wss://api.stylistgpt.ai/cable"
  );
};

export const cable = createConsumer(
  getWebSocketUrl() + (token ? `?token=${encodeURIComponent(token)}` : "")
);
